const url = process.env.VUE_APP_API_URL + "ending/reports"

export default {
  namespaced: true,

  state: {
    records: [],
    loading: false,
    cashOutDetails: [],
    cashOutDetailsLoading: false
  },
  mutations: {
    setRecords (state, val) {
      state.records = val
    },
    setRecordsLoading (state, val) {
      state.loading = val
    },
    setCashOutDetails(state, val) {
      state.cashOutDetails = val
    },
    setCashOutDetailsLoading(state, val) {
      state.cashOutDetailsLoading = val
    }
  },

  actions: {
    async getRecords({ commit, rootState }, data) {
      commit("setRecordsLoading", true)

      try {
        const response = await fetch(`${url}/cashout?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setRecords", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setRecordsLoading", false)
      }
    },

    async getCashOutRequests({ commit, rootState }, data) {
      commit("setCashOutDetailsLoading", true)

      try {
        const response = await fetch(`${url}/cashout_request?${data}` , {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        })

        const res = await response.json()
        
        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setCashOutDetails", res.records)

          return res
        }
      } catch(error) {
        const errorStatus = error.response.status
        
        if (errorStatus==401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setRefreshError", "Submitted invalid data", { root: true })
        }
      } finally {
        commit("setCashOutDetailsLoading", false)
      }
    },
  }
}